import core from '@/admin/core';
import { getEnvSettingsSync } from '@/admin/envSettings';

/**
 * フラグによってパスを変換する関数
 * @param path 
 * @returns hostingUrl/path or hostingUrl/#/path
 */
export const convertToHostingPath = (path: string) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const hostingUrl = core.hostingUrl;

  // v2ホスティングフラグの取得
  const settings = getEnvSettingsSync();
  const enableV2SiteHosting = settings?.enableV2SiteHosting ?? false;

  if (enableV2SiteHosting) {
    const cleanedPath = normalizedPath.replace('/#/', '/').replace('#/', '/');
    return `${hostingUrl}${cleanedPath}`;
  } else if (normalizedPath.includes('/#')) {
    return `${hostingUrl}${normalizedPath}`;
  }

  return `${hostingUrl}/#${normalizedPath}`;
};
